import React, { useEffect, useState } from "react";
import "./styles.scss";
import { Checkbox, CircularProgress } from "@mui/material";
import { useStateValue } from "../../../store/index";
import {
  getIsipCodeValid,
  getCartList,
} from "../../../store/homeAction/action";

import { ReactComponent as FilledIcon } from "../../../assets/icons/filledCheckbox.svg";
import { ReactComponent as UnFilledIcon } from "../../../assets/icons/unfilledCheckbox.svg";

const InstallationRequirement = (props) => {
  const [{ zipCodePopup, cartListData }, dispatch] = useStateValue();

  const { data, checked, identity, isMycart } = props;
  const [value, setValue] = useState({
    installation: false,
    fall_prevention: false,
  });
  const [isLoading, setIsLoading] = useState({
    installation: false,
    fall_prevention: false,
  });

  const handleCheckBox = (event) => {
    let temp = sessionStorage.getItem("iszipAuth");
    if (temp === "" || null) {
      dispatch({
        type: "SET_ZIP_CODE_POPUP",
        value: true,
        data: {
          ...zipCodePopup?.zipCodeData,
          // [event.target.name]: event.target.checked,
        },
      });
    } else {
      let installation = "";
      let fall_prevention = "";
      if (!value?.installation && !value?.fall_prevention) {
        installation = true;
        fall_prevention = true;
      } else {
        installation =
          event.target.name === "installation"
            ? event.target.checked
            : zipCodePopup?.zipCodeData?.installation;
        fall_prevention =
          event.target.name === "fall_prevention"
            ? event.target.checked
            : zipCodePopup?.zipCodeData?.fall_prevention;
      }
      let payload = {
        installation: installation,
        fall_prevention: fall_prevention,
        session_key: sessionStorage.getItem("session_key"),
        zip: sessionStorage.getItem("iszipAuth"),
      };
      setIsLoading((prevLoading) => ({
        ...prevLoading,
        [identity]: true,
      }));
      //api trigger to verify zip code
      getIsipCodeValid((res, error) => {
        dispatch({
          type: "SET_ZIP_CODE_POPUP",
          data: res?.data ? res?.data : error?.data,
        });
        setIsLoading((prevLoading) => ({
          ...prevLoading,
          [identity]: false,
        }));
        dispatch({
          type: "SET_IS_LOADING",
          value: true,
        });
        if (res?.data?.session_key) {
          sessionStorage.setItem("session_key", res?.data?.session_key);
        }
        sessionStorage.setItem("iszipAuth", res?.status ? res?.data?.zip : "");
        let payload = {
          session_key: sessionStorage.getItem("session_key"),
        };
        getCartList((res) => {
          dispatch({
            type: "SET_CARTLIST_DATA",
            data: res,
          });
          sessionStorage.setItem(
            "iszipAuth",
            res?.data?.installation_content?.postal_code
          );
          dispatch({
            type: "SET_ZIP_CODE_POPUP",
            value: false,
            data: {
              installation: res?.data?.installation_content?.installation,
              fall_prevention: res?.data?.installation_content?.fall_prevention,
              zipCode: res?.data?.installation_content?.postal_code,
            },
          });
          dispatch({
            type: "SET_IS_LOADING",
            value: false,
          });
        }, payload);
      }, payload);
    }
  };
  useEffect(() => {
    let isValid = sessionStorage.getItem("iszipAuth");
    if (zipCodePopup?.zipCodeData) {
      if (
        zipCodePopup?.zipCodeData?.installation !== true &&
        zipCodePopup?.zipCodeData?.fall_prevention !== true
      ) {
        setValue((prev) => ({
          ...prev,
          [identity]: zipCodePopup?.zipCodeData[identity],
        }));
        sessionStorage.setItem("iszipAuth", "");
      }
      if (isValid !== "") {
        setValue((prev) => ({
          ...prev,
          [identity]: zipCodePopup?.zipCodeData[identity],
        }));
      }
    }
  }, [zipCodePopup?.zipCodeData]);

  useEffect(() => {
    const { installation_content } = cartListData?.data || {};
    if (installation_content) {
      const { installation, fall_prevention } = installation_content;
      setValue({
        installation,
        fall_prevention,
      });
    }
  }, [cartListData]);

  return (
    <div className="installation-container">
      {isMycart ? (
        ""
      ) : (
        <div className="h3">
          <h3>{data?.title}</h3>
        </div>
      )}
      <div className="description">
        <p
          dangerouslySetInnerHTML={{
            __html: data?.description,
          }}
        />
      </div>
      {checked ? (
        <div className="checkbox">
          {!isLoading[identity] ? (
            <Checkbox
              icon={<UnFilledIcon />}
              checkedIcon={<FilledIcon />}
              inputProps={{ "aria-label": "controlled" }}
              checked={value[identity]}
              name={identity}
              onChange={handleCheckBox}
            />
          ) : (
            <CircularProgress className="progress-circle" />
          )}
          <h4>
            {data?.checked_content}{" "}
            {data?.price ? (
              <>
                -{" "}
                <span>
                  {data?.currency_symbol}
                  {data?.price}
                </span>
              </>
            ) : null}
          </h4>
        </div>
      ) : null}
    </div>
  );
};

export default InstallationRequirement;
